import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Mail, ArrowRight } from "lucide-react";

export default function PaymentSuccessModal({ order, onClose }) {
    return (
        <div className="fixed inset-0 z-50 bg-femcare-purple/70 backdrop-blur-sm flex items-center justify-center p-4" data-testid="success-modal">
            <div className="bg-white rounded-3xl w-full max-w-md shadow-2xl p-8 text-center">
                <div className="w-20 h-20 rounded-full bg-femcare-pink/15 flex items-center justify-center mx-auto mb-6">
                    <CheckCircle2 className="w-10 h-10 text-femcare-pink" />
                </div>
                <h3 className="editorial-headline text-4xl text-femcare-purple mb-3">You're in.</h3>
                <p className="text-femcare-purple/70 mb-6 leading-relaxed">
                    Your order <span className="font-mono text-xs bg-femcare-petal/60 px-2 py-1 rounded">{order?.receipt}</span> is paid.
                    Download the Femcare app and sign in with <strong>{order?.customer_email}</strong> to activate.
                </p>
                <div className="bg-femcare-petal/40 rounded-2xl p-4 mb-6 text-left">
                    <p className="text-xs uppercase tracking-[0.2em] text-femcare-accent mb-2">Order summary</p>
                    {(order?.items || []).map((i, k) => (
                        <div key={k} className="flex justify-between text-sm py-1">
                            <span className="text-femcare-purple">{i.name}</span>
                            <span className="text-femcare-purple/70">₹{i.price}/{i.period}</span>
                        </div>
                    ))}
                    <div className="flex justify-between border-t border-femcare-border mt-2 pt-2 text-sm font-medium">
                        <span className="text-femcare-purple">Total paid</span>
                        <span className="text-femcare-pink">₹{order?.amount_inr}</span>
                    </div>
                </div>
                <div className="space-y-3">
                    <a href="mailto:support@femcare.life" className="inline-flex items-center gap-2 text-sm text-femcare-accent hover:text-femcare-pink">
                        <Mail className="w-4 h-4" /> Receipt sent to your email
                    </a>
                    <button onClick={onClose} className="w-full btn-primary justify-center" data-testid="success-close">
                        Continue exploring <ArrowRight className="w-4 h-4" />
                    </button>
                </div>
            </div>
        </div>
    );
}
